import Quill from "quill";
const BlockEmbed = Quill.import("blots/block/embed");

class ImageBlot extends BlockEmbed {
    static create({ attributes, data }) {
        let node = super.create();
        $(node).attr(attributes);
        _.forEach(data, (value, key) => {
            $(node).attr("data-" + key, value);
        });
        return node;
    }

    static value(node) {
        let attributes = {};
        _.forEach(node.attributes, (attr) => {
            attributes[attr.name] = attr.value;
        });
        return {
            attributes,
            data: $(node).data(),
        };
    }
}

export default ImageBlot;
